import styles from "../../assets/styles/Transaction/Transaction.module.scss";
import {
  AppPage,
  MimaButton,
  MimaNewFilter,
  MimaTable,
} from "../../components";

import React, { useMemo, useState } from "react";
import constant from "../../utils/constant";
import moment from "moment";
import { amountFormatter } from "../../utils/utils";
import { downloadXlsx2 } from "../../utils/download";

const ProvidusTransactions = ({
  filterHandler,
  onLimitChange,
  data,
  currentPage,
  setCurrentPage,
  limit,
  isLoading,
  isFetching,
  setSearchQuery,
}) => {
  const [showFilter, setShowFilter] = useState(false);

  const filterByData = [{ value: "Date", key: "createdAt" }];

  const tableData = useMemo(() => {
    if (data?.status === constant.Success) {
      return data?.data?.value || [];
    }
    return [];
  }, [data]);

  const tableColumns = [
    {
      Header: "Date",
      accessor: "createdAt",
      Cell: ({ cell }) => {
        const date = cell.row.original.createdAt;
        return <span>{moment(date).format("DD/MM/YYYY HH:mm a")}</span>;
      },
    },
    {
      Header: "Sender Name",
      accessor: "sourceAccountName",
    },
    {
      Header: "Recipient Account Number",
      accessor: "accountNumber",
    },
    {
      Header: "Transaction Amount",
      accessor: "transactionAmount",
      Cell: ({ cell }) => {
        const transactionAmount = cell.row.original.transactionAmount;
        const formattedAmount =
          amountFormatter("NGN").format(transactionAmount);
        return <span>{formattedAmount}</span>;
      },
    },
    {
      Header: "Narration",
      accessor: "tranRemarks",
      Cell: ({ cell }) => {
        const narrations = cell.value;
        return (
          <span>
            {narrations.length > 30
              ? narrations.substring(0, 30) + "..."
              : narrations}
          </span>
        );
      },
    },
    {
      Header: "Bank Name",
      accessor: "sourceBankName",
    },
  ];

  const printData = tableData.map((item) => ({
    Date: item?.createdAt
      ? moment(item?.createdAt).format("DD-MM-YYYY HH:mm a")
      : "",
    "Sender Name": item?.sourceAccountName || "",
    "Recipient Account Number": item?.accountNumber || "",
    "Transaction Amount":
      amountFormatter(item.currencyCode).format(item.transactionAmount) || "",
    Narration: item?.tranRemarks || "",
    "Bank Name": item?.sourceBankName || "",
  }));
  return (
    <AppPage pageTitle="Providus Bank Transactions">
      <>
        <div className={styles.filterClass}>
          <MimaButton
            title={showFilter ? "Close Filter" : "Filter"}
            onClick={() => setShowFilter(!showFilter)}
          />
          <MimaButton
            title={`Download Report`}
            width={27}
            onClick={() => {
              downloadXlsx2(printData);
            }}
          />
        </div>
        <MimaNewFilter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          filterByData={filterByData}
          filterHandler={filterHandler}
        />

        <MimaTable
          tableData={tableData}
          tableColumns={tableColumns}
          searchPlaceholder="Search Transaction"
          searchVariant="wide"
          totalItems={data?.data?.totalCounts}
          onLimitChange={onLimitChange}
          isLoading={isLoading}
          isFetching={isFetching}
          limit={limit}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setSearchQuery={setSearchQuery}
        />
      </>
    </AppPage>
  );
};

export default ProvidusTransactions;
